import { z } from 'zod'

export const STRATALYST_MODULE_RUN_CONTRACT_VERSION = '1.0.0' as const
const passthroughResponseSchema = z.unknown()

export const stratalystModuleRunConsolidateResponseSchema = passthroughResponseSchema
export const stratalystModuleRunVersionsResponseSchema = passthroughResponseSchema
export const stratalystModuleRunModelsResponseSchema = passthroughResponseSchema
export const stratalystModuleRunConfirmResponseSchema = passthroughResponseSchema
export const stratalystModuleRunDashboardResponseSchema = passthroughResponseSchema
export const stratalystModuleRunCancelResponseSchema = passthroughResponseSchema
export const stratalystModuleRunRerunResponseSchema = passthroughResponseSchema
export const stratalystModuleRunVariantsResponseSchema = passthroughResponseSchema
export const stratalystModuleRunDetailResponseSchema = passthroughResponseSchema
export const stratalystModuleRunStartResponseSchema = passthroughResponseSchema

export type StratalystModuleRunConsolidateResponse = z.infer<typeof stratalystModuleRunConsolidateResponseSchema>
export type StratalystModuleRunVersionsResponse = z.infer<typeof stratalystModuleRunVersionsResponseSchema>
export type StratalystModuleRunModelsResponse = z.infer<typeof stratalystModuleRunModelsResponseSchema>
export type StratalystModuleRunConfirmResponse = z.infer<typeof stratalystModuleRunConfirmResponseSchema>
export type StratalystModuleRunDashboardResponse = z.infer<typeof stratalystModuleRunDashboardResponseSchema>
export type StratalystModuleRunCancelResponse = z.infer<typeof stratalystModuleRunCancelResponseSchema>
export type StratalystModuleRunRerunResponse = z.infer<typeof stratalystModuleRunRerunResponseSchema>
export type StratalystModuleRunVariantsResponse = z.infer<typeof stratalystModuleRunVariantsResponseSchema>
export type StratalystModuleRunDetailResponse = z.infer<typeof stratalystModuleRunDetailResponseSchema>
export type StratalystModuleRunStartResponse = z.infer<typeof stratalystModuleRunStartResponseSchema>
